module.exports = __webpack_public_path__ + "img/logo__default.b3db2ddd.svg";